import tw from 'twin.macro'
import { useLocation } from '@reach/router'
import Link from '@/components/link-component'
import HashtagIcon from '@/icons/bwi/hashtag.svg'
import { smoothScroll } from '@/utils/dom'
import { slugify } from '@/utils/strings'

export type SizeType = 'h2' | 'h3'

export default function HeadingWithAnchor({ type, title }: { type: SizeType; title: string }) {
  const { origin, pathname } = useLocation()
  const anchor = slugify(title)
  return (
    <div id={anchor} className="group" tw="relative">
      <Link
        title={`#${anchor}`}
        to={`#${anchor}`}
        onClick={(event) => {
          navigator.clipboard.writeText(`${origin}${pathname}#${anchor}`)
          smoothScroll(event)
        }}
        tw="absolute text-primaryBlue opacity-0 group-hover:opacity-40 hover:opacity-100! transition-opacity duration-500"
        css={[type === 'h2' && tw`w-6 h-6 top-2 -left-7`, type === 'h3' && tw`w-5 h-5 top-2 -left-6`]}
      >
        <HashtagIcon />
      </Link>
      <Heading type={type}>{title}</Heading>
    </div>
  )
}

function Heading({ type, children }: { type: SizeType; children: React.ReactNode }) {
  if (type === 'h2') return <h2>{children}</h2>
  if (type === 'h3') return <h3>{children}</h3>
}
